// deno-fmt-ignore-file
import { Tuple } from '../../types/tuple.mjs';
import { AddImmutable } from '../../action/_add_immutable.mjs';
export function FromTuple(types) {
    const result = AddImmutable(Tuple(types));
    return result;
}
